import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class ReEntry extends React.Component {
  reEntryAction() {
    let detail = this.props.detail;
    
    let chk = confirm('このインフルエンサーを再度エントリー状態にしてもよろしいですか？\n変更すると操作を戻すことができません。ご注意ください。');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/influencer/status_update', { project_id: detail.project_id, insta_user_id: detail.insta_user_id, update: { column: 're_entry' } },
      function(res){
        this.props.close_ev.bind(this)();
        this.props.base.event.updateData('workflow', res.body.workflow);
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    // アクション
    if( detail.workflow_status.is_assign == 1 ){
      return (
        <div>
          <li className="on" onClick={this.reEntryAction.bind(this)}>
            {this.props.button}
          </li>
        </div>
      );
    }
    
    // 使用できない
    return (
      <OverlayTrigger placement="left" delayShow={50} overlay={<Tooltip>案件依頼をしていない場合は、<br />再エントリーできません</Tooltip>}>
        <li className="off">
          {this.props.button}
        </li>
      </OverlayTrigger>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ReEntry;